export const getStaticBanner = () =>
  Array.from({ length: 3 }, (_, i) => `./assets/images/banner/${i + 1}.png`);
